import { get, post } from "../api_helper";

const CreatePaymentIntent = async (data) => {
  const url = "payments/create-payment-intent";
  const response = await post(url, data);
  return response;
};
const SavePaymentData = async (data) => {
  const url = "payments/save-payment-data";
  const response = await post(url, data);
  return response;
};

const GetAllPayments = async () => {
  const url = "payments/get-all-payments";
  const response = await get(url);
  return response;
};

export { CreatePaymentIntent, SavePaymentData, GetAllPayments };
